import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const AsideView  = r => require.ensure([], () => r(require('@/components/aside_view')), 'AsideView')

export default new Router({
  mode: 'history',
  routes: [
    { 
      path: '/login', 
      component: () => import('@/pages/login/login'), 
      name: 'Login'
    },{
      path: '/',
      component: AsideView,
      children: [
        { path: '/overview', component: () => import('@/pages/overview/overview'), name: 'Overview' },
        { path: '/overview/projectmanager', component: () => import('@/pages/overview/projectmanager'), name: 'Projectmanager'},
        { path: '/overview/projectmanager/:appName', component: () => import('@/pages/overview/details/details'), name: 'Configure' }
      ]
    },{
      path: '/warning',
      component: AsideView,
      children: [
        { path: '/warning', component: () => import('@/pages/warning/index'), name: 'Warning' },
        { path: '/warning/addrule', component: () => import('@/pages/warning/rule'), name: 'add_rule' },
        { path: '/warning/updaterule/:ruleId', component: () => import('@/pages/warning/rule'), name: 'update_rule' },
        { path: '/warning/history', component: () => import('@/pages/warning/warning_history'), name: 'warning_history' },
        { path: '/warning/details/:ruleId', component: () => import('@/pages/warning/warning_details'), name: 'warning_details' },
      ]
    },{
      path: '/host',
      component: AsideView,
      redirect: 'Host',
      children: [
        { path: '/host', component: () => import('@/pages/machine/host'), name: 'Host' },
        { path: '/host/details/:machineIp', component: () => import('@/pages/machine/details/details'), name: 'Hostdetails' },
        { path: '/host/addmachine', component: () => import('@/pages/machine/details/add_machine'), name: 'AddMachine' },
      ]
    },{
      path: '/service',
      component: AsideView,
      redirect: 'Service',
      children: [
        { path: '/service', component: () => import('@/pages/serve/service'), name: 'Service' },
        { path: '/service/details/:serviceID', component: () => import('@/pages/serve/details/details'), name: 'Servedetails' },
        { path: '/service/addservice', component: () => import('@/pages/serve/details/add_serve'), name: 'AddServe' },
      ]
    },{
      path: '/abnormal',
      component: AsideView,
      redirect: 'Abnormal',
      children: [
        { path: '/abnormal', component: () => import('@/pages/abnormal/abnormal'), name: 'Abnormal' },
        { path: '/abnormal/details', component: () => import('@/pages/abnormal/details/details'), name: 'AbnormalDetails' },
      ]
    },{
      path: '/video',
      component: AsideView,
      redirect: 'Video',
      children: [
        { path: '/video', component: () => import('@/pages/video/index'), name: 'Video'}
      ]
    },{
      path: '/room',
      component: AsideView,
      redirect: 'Room',
      children: [
        { path: '/room', component: () => import('@/pages/room/room'), name: 'Room' },
        { path: '/room/meet/:roomId', component: () => import('@/pages/room/details/meet'), name: 'roomMeet' },
        { path: '/room/rtcp/:pubID', component: () => import('@/pages/room/details/rtcp'), name: 'roomRtcp' },
        { path: '/room/talk/:roomId', component: () => import('@/pages/room/details/talk'), name: 'roomTalk' },
        { path: '/room/rtmp/', component: () => import('@/pages/room/details/rtmp'), name: 'roomRtmp' },
      ]
    },{
      path: '/test',
      component: AsideView,
      redirect: 'Test',
      children: [
        { path: '/test', component: () => import('@/pages/test/test'), name: 'Test' }
      ]
    },{
      path: '/system',
      component: AsideView,
      redirect: 'System',
      children: [
        { path: '/system', component: () => import('@/pages/system/index'), name: 'System' }
      ]
    }
  ] 
})


// WEBPACK FOOTER //
// ./src/router/index.js